(function () {
  const getInt = (value, fallback) => {
    const number = parseInt(value, 10);
    return Number.isFinite(number) ? number : fallback;
  };

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const randomBetween = (min, max) => {
    if (max <= min) return min;
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const storage = {
    get(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (error) {
        return null;
      }
    },
    set(key, value) {
      try {
        window.localStorage.setItem(key, String(value));
      } catch (error) {
        return false;
      }
      return true;
    }
  };

  const initPromoTags = (scope) => {
    scope.querySelectorAll('.jc-promo-tags').forEach((block) => {
      const toggle = block.querySelector('.jc-promo-tags__toggle');
      if (!toggle || toggle.dataset.initialized === 'true') return;

      toggle.dataset.initialized = 'true';
      toggle.addEventListener('click', () => {
        const expanded = block.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.textContent = expanded ? toggle.dataset.expandedLabel || '-' : toggle.dataset.collapsedLabel || '+';
      });
    });
  };

  const normalizeRange = (min, max) => {
    if (min > max) return [max, min];
    return [min, max];
  };

  const initVirtualSales = (scope) => {
    scope.querySelectorAll('.jc-virtual-sales__number').forEach((numberEl) => {
      const productId = numberEl.dataset.productId || numberEl.dataset.productHandle;
      if (!productId) return;

      const range = normalizeRange(getInt(numberEl.dataset.min, 0), getInt(numberEl.dataset.max, 0));
      const min = range[0];
      const max = range[1];
      const key = `jc_virtual_sales_${productId}`;
      const storedValue = getInt(storage.get(key), NaN);
      let nextValue;

      if (Number.isFinite(storedValue)) {
        const increment = randomBetween(0, 3);
        nextValue = clamp(storedValue + increment, min, max);
      } else {
        nextValue = randomBetween(min, max);
      }

      storage.set(key, nextValue);
      numberEl.textContent = nextValue;
    });
  };

  const initVirtualStock = (scope) => {
    scope.querySelectorAll('.jc-virtual-stock__number').forEach((numberEl) => {
      const productId = numberEl.dataset.productId || numberEl.dataset.productHandle;
      if (!productId) return;

      const range = normalizeRange(getInt(numberEl.dataset.min, 1), getInt(numberEl.dataset.max, 1));
      const min = range[0];
      const max = range[1];
      const key = `jc_virtual_stock_${productId}`;
      const storedValue = getInt(storage.get(key), NaN);
      let nextValue;

      if (Number.isFinite(storedValue)) {
        const decrement = randomBetween(0, 2);
        nextValue = clamp(storedValue - decrement, min, max);
      } else {
        nextValue = randomBetween(min, max);
      }

      storage.set(key, nextValue);
      numberEl.textContent = nextValue;
    });
  };

  const initJoyCraftProductDetail = (scope) => {
    const root = scope || document;
    if (
      !root.querySelector('.jc-promo-tags') &&
      !root.querySelector('.jc-virtual-sales__number') &&
      !root.querySelector('.jc-virtual-stock__number')
    ) {
      return;
    }

    initPromoTags(root);
    initVirtualSales(root);
    initVirtualStock(root);
  };

  document.addEventListener('DOMContentLoaded', () => initJoyCraftProductDetail(document));
  document.addEventListener('shopify:section:load', (event) => initJoyCraftProductDetail(event.target));
})();
